import { jsx as _jsx } from "react/jsx-runtime";
import { TextM } from '../../../../infra/dls/components/typography';
import styles from './styles.module.scss';
var suggestions = ['How much did I make today?', 'Which service sells best?', 'Was it a good week for me?'];
export var ChatSuggestions = function (_a) {
    var onSuggestionClick = _a.onSuggestionClick;
    return (_jsx("div", { className: styles.chatPlaceholder, children: _jsx("div", { className: styles.suggestionPills, children: suggestions.map(function (suggestion) { return (_jsx("button", { className: styles.suggestionPill, onClick: function () { return onSuggestionClick(suggestion); }, children: _jsx(TextM, { color: "primary", children: suggestion }) }, suggestion)); }) }) }));
};
